<!--
/*******************************************************************************
*@ 컴포넌트명   : TrsaccInptRpt2.vue
*@ 컴포넌트설명 : 타행이체 - 이체확인증
*@ 사용전문     :  
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 
********************************************************************************/
-->
<template>
  <section class="transfer">
    <popup :opened.sync="openData" :use-header="true" :use-footer="true" class="popup" @cancel="popupClose">
      <template #subtitle>
        <h2>{{ /*이체 확인증 (타행)*/ $t("MPAY-04-01-07-01") }}</h2>
      </template>
      <template #content>
        <div class="divider">
          <span class="divider-date">{{ /*신청 일시*/ $t("MPAY-04-01-07-02") }} : {{ $getGlobalDateFmt(detailInfo.drblYms) }}</span>
        </div>
        <div class="cont-tit">
          <h6>{{ /*출금정보*/ $t("MPAY-04-01-07-03") }}</h6>
        </div>
        <dl class="dlist dlist-item--type6">
          <dt>{{ /*출금 계좌번호*/ $t("MPAY-04-01-07-04") }}</dt>
          <dd class="right">{{ detailInfo.drwotAcno }}</dd>
          <dt>{{ /*예금주명*/ $t("MLON-01-01-11-05") }}</dt>
          <dd class="right">{{ detailInfo.drwotDpstrName }}</dd>
          <dt>{{ /*출금 금액*/ $t("MPAY-04-01-07-05") }}</dt>
          <dd class="right">
            <span class="exchange-unit">{{ detailInfo.drwotCncycd }}</span>
            <span class="amount">{{ $num(detailInfo.anticiDrwotAmt) }}</span>
          </dd>
          <dt>{{ /*수수료*/ $t("MPAY-04-01-07-06") }}</dt>
          <dd class="right">
            <span class="exchange-unit">{{ detailInfo.drwotCncycd }}</span>
            <span class="amount">{{ $num(detailInfo.anticiFee) }}</span>
          </dd>
          <dt>{{ /*송금메모*/ $t("MINQ-02-02-03-13") }}</dt>
          <dd class="right">{{ detailInfo.drwotTrsaccMemo }}</dd>
        </dl>
        <div class="cont-tit">
          <h6>{{ /*입금 정보*/ $t("MPAY-04-01-07-08") }}</h6>
        </div>
        <dl class="dlist dlist-item--type6">
          <template v-if="siteCode != $config.SITECODE_OGAUC">
            <dt>{{ /* 은행명 */ $t("MPAY-04-01-07-09") }}</dt>
            <dd class="right">{{ detailInfo.mnrcvOthrBnkName }}</dd>
          </template>
          <template v-if="siteCode == $config.SITECODE_OGMMR">
            <dt>{{ /* 입금 지점 */ $t("MPAY-02-01-26-17") }}</dt>
            <dd class="right">{{ detailInfo.mnrcvBrnName }}</dd>
          </template>
          <template v-if="siteCode == $config.SITECODE_OGIND">
            <dt>{{ /* IFSC코드 */ $t("MPAY-02-01-08-04") }}</dt>
            <dd class="right">{{ detailInfo.rcevnBnkIfscCode }}</dd>
          </template>
          <dt>{{ /*입금 계좌번호*/ $t("MPAY-04-01-07-10") }}</dt>
          <dd class="right">{{ detailInfo.mnrcvAcno }}</dd>
          <dt>{{ /*입금 금액*/ $t("MPAY-04-01-07-11") }}</dt>
          <dd class="right">
            <span class="exchange-unit">{{ detailInfo.mnrcvCncycd }}</span>
            <span class="amount">{{ $num(detailInfo.mnrcvTrsaccAmt) }}</span>
          </dd>

          <template v-if="siteCode == $config.SITECODE_OGMMR">
            <dt>{{ /*지점명*/ $t("MPRS-02-02-02-06") }}</dt>
            <dd class="right">{{ detailInfo.mnrcvBrnName }}</dd>
          </template>
          <dt>{{ /*수취인*/ $t("MPAY-04-01-07-12") }}</dt>
          <dd class="right">{{ detailInfo.mnrcvDpstrName }}</dd>
          <dt>{{ /*Particulars*/ /*수취인 참조내용*/ siteCode == $config.SITECODE_OGAUC ? $t("MPAY-02-01-12-22") : $t("MPAY-04-01-06-A14") }}</dt>
          <dd class="right">{{ detailInfo.mnrcvDraweRefCtnt }}</dd>
          <template v-if="siteCode == $config.SITECODE_OGAUC">
            <dt>{{ /*Code*/ $t("MPAY-04-01-10-13") }}</dt>
            <dd class="right">{{ detailInfo.draweCd }}</dd>
          </template>
        </dl>
        <template v-if="siteCode == $config.SITECODE_OGAUC || siteCode == $config.SITECODE_OGIND">
          <dl class="dlist dlist-item--type6">
            <template v-if="siteCode == $config.SITECODE_OGAUC">
              <dt>{{ /*Reference*/ $t("MPAY-02-01-12-21") }}</dt>
              <dd class="right">{{ detailInfo.remark }}</dd>
            </template>
            <template v-else-if="siteCode == $config.SITECODE_OGIND">
              <dt>{{ /*송금방식*/ $t("MPAY-02-01-24-10") }}</dt>
              <dd class="right">{{ $config[`RMTANC_PTRN_DSTCD_${detailInfo.rmtancPtrnDstcd}`] }}</dd>
              <dt>{{ /*처리 상태*/ $t("MPAY-04-01-11-17") }}</dt>
              <dd class="right">{{ $t(`${detailInfo.ovsesRmtancPrcssDstcd}_해외송금처리구분코드`) }}</dd>
              <dt>{{ /*송금 확인 번호*/ $t("MPAY-04-01-11-18") }}</dt>
              <dd class="right">{{ detailInfo.utrNo }}</dd>
            </template>
          </dl>
        </template>
        <ul class="ulist ulist-type--bullet">
          <li>{{ /*위의 내용이 정상적으로 처리되었음을 확인합니다. */ $t("MPAY-04-01-10-18") }}</li>
          <li>{{ /*이체확인증은 고객 편의를 위하여 제공되는 것으로 거래의 참고용으로만 사용될 수 있습니다.*/ $t("MPAY-04-01-10-19") }}</li>
        </ul>
        <div class="bank-name">
          <template v-if="siteCode == $config.SITECODE_OGHCM">
            <template v-if="operGroupCd == 'VN1'">{{ $t(`${siteCode}_지점명칭`) }}</template>
            <template v-else>{{ $t(`oghni_지점명칭`) }}</template>
          </template>
          <template v-else>{{ $t(`${siteCode}_지점명칭`) }}</template>
        </div>
      </template>
      <template #footer>
        <button class="btn bottom positive" @click="popupClose()">{{ /*확인*/ $t("MPAY-04-01-10-21") }}</button>
      </template>
    </popup>
  </section>
</template>

<script>
import { mapFields } from "vuex-map-fields";

export default {
  props: {
    opened: {
      type: Boolean,
      default: false,
    },
    detailInfo: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapFields(["siteCode", "operGroupCd"]),
    openData: {
      get() {
        return this.opened;
      },
      set(value) {
        this.$emit("update:opened", value);
      },
    },
  },
  methods: {
    popupClose() {
      this.openData = false;
      this.$emit("popupClose", false);
    },
  },
};
</script>
